export const mockServices = [
  {
    title: 'Food Manufacturing Plant Setup',
    description: 'Complete end-to-end support for setting up food manufacturing facilities with optimal workflow design and equipment selection.'
  },
  {
    title: 'New Recipe Development',
    description: 'Innovative recipe creation tailored to market demands, consumer preferences, and manufacturing capabilities.'
  },
  {
    title: 'Recipe Enhancement',
    description: 'Optimization of existing recipes for better taste, texture, nutritional value, and cost-effectiveness.'
  },
  {
    title: 'Shelf Life Solutions',
    description: 'Advanced preservation techniques and formulation strategies to extend product shelf life without compromising quality.'
  }
];

export const mockStats = [
  {
    value: '120+',
    label: 'Recipes Prepared'
  },
  {
    value: '12',
    label: 'Years of Experience'
  },
  {
    value: '52+',
    label: 'Companies Associated With'
  },
  {
    value: '10+',
    label: 'Worked With Foreign Clients'
  }
];

export const mockClients = [
  { name: 'Vaidik Masale', image: 'https://customer-assets.emergentagent.com/job_b631f232-bc52-4c4f-8b09-51e1826d5c65/artifacts/8hdq2nne_client13.jpeg' },
  { name: 'Atharv Masale', image: 'https://customer-assets.emergentagent.com/job_b631f232-bc52-4c4f-8b09-51e1826d5c65/artifacts/4wgy6ra0_client12.jpeg' },
  { name: 'Festee Optimal Nutrition', image: 'https://customer-assets.emergentagent.com/job_b631f232-bc52-4c4f-8b09-51e1826d5c65/artifacts/g9y5eq03_client11.jpeg' },
  { name: 'Panchatatva', image: 'https://customer-assets.emergentagent.com/job_b631f232-bc52-4c4f-8b09-51e1826d5c65/artifacts/vdtpixdc_client10.jpeg' },
  { name: 'Bell Mist', image: 'https://customer-assets.emergentagent.com/job_b631f232-bc52-4c4f-8b09-51e1826d5c65/artifacts/irybgv7g_client9.jpeg' },
  { name: 'MR Home Made', image: 'https://customer-assets.emergentagent.com/job_b631f232-bc52-4c4f-8b09-51e1826d5c65/artifacts/r8nad5n4_client8.jpeg' },
  { name: 'Meera Spices', image: 'https://customer-assets.emergentagent.com/job_b631f232-bc52-4c4f-8b09-51e1826d5c65/artifacts/n4cxpqhw_client7.jpeg' },
  { name: 'Paarna', image: 'https://customer-assets.emergentagent.com/job_b631f232-bc52-4c4f-8b09-51e1826d5c65/artifacts/pk1tzzhm_client6.jpeg' },
  { name: 'Kamaal Masale', image: 'https://customer-assets.emergentagent.com/job_b631f232-bc52-4c4f-8b09-51e1826d5c65/artifacts/gxuh05j0_client5.jpeg' },
  { name: 'MBS Food and Spices', image: 'https://customer-assets.emergentagent.com/job_b631f232-bc52-4c4f-8b09-51e1826d5c65/artifacts/kx30hvwq_client3.jpeg' },
  { name: 'Annapurna', image: 'https://customer-assets.emergentagent.com/job_b631f232-bc52-4c4f-8b09-51e1826d5c65/artifacts/u5g2xerw_client14.jpeg' },
  { name: 'Fyuzo Foods', image: 'https://customer-assets.emergentagent.com/job_b631f232-bc52-4c4f-8b09-51e1826d5c65/artifacts/zr2bqamf_client1.jpeg' }
];

export const mockTestimonials = [
  {
    name: 'John Smith',
    company: 'ABC Foods Inc.',
    text: 'BSFOODCONSULTANT transformed our production process. Their expertise in recipe development is unmatched!',
    rating: 5
  },
  {
    name: 'Sarah Johnson',
    company: 'Fresh Delights',
    text: 'Working with their team helped us extend our product shelf life by 40%. Highly professional and knowledgeable.',
    rating: 5
  },
  {
    name: 'Michael Chen',
    company: 'Gourmet Solutions',
    text: 'The plant setup consultation was invaluable. They understood our needs and delivered beyond expectations.',
    rating: 5
  }
];